var organizationAdministrators;

import UserOrganizationsContainer from '../users_organizations_container.js';

import OrganizationsTab from 'trunks/vue/admin/components/organizations/organization_tab.js';

import AdministratorItem from 'trunks/vue/admin/components/organizations/organization_administrators/administrators_item.js';

import AddAdminsModal from 'trunks/vue/admin/compositions/organizations/responses/add_members_modals/add_admins_modal.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

export default organizationAdministrators = Vue.extend({
  components: {
    'user-organization-container': UserOrganizationsContainer,
    'organization-tab': OrganizationsTab,
    'administrator-item': AdministratorItem
  },
  props: {
    organization: {
      type: Object
    },
    organizationApplicationsCount: {
      type: Number
    },
    organizationAdministratorsCount: {
      type: Number
    },
    activeTab: {
      type: String
    }
  },
  data: function() {
    return {
      resources: `/admin/organizations/${this.organization.id}/administrators`,
      administratorsList: [],
      accessesList: [],
      organizationState: OrganizationState
    };
  },
  watch: {
    'organizationState.name': function() {
      return this.organization.name = this.organizationState.name;
    }
  },
  computed: {
    administratorsCount: function() {
      if (this.administratorsList.length === 0) {
        return this.organizationAdministratorsCount;
      } else {
        return this.administratorsList.length;
      }
    }
  },
  template: `<user-organization-container :title="organization.name">
  <template slot="content">
    <organization-tab :organizationId="organization.id"
                      :pendingOrganizationApplicationsCount='organizationApplicationsCount'
                      :activeTab="activeTab" />
    <div class="organization-administrators">
      <div class="administrators-add">
        <span class="btn btn-primary" @click="openAddAdminsModal">新增</span>
        <span class="helper-text">共{{administratorsCount}}条数据</span>
      </div>
      <div class="administrators-list">
        <administrator-item v-for="administrator in administratorsList"
                            :key="administrator.id"
                            :resources="resources"
                            :organization="organization"
                            :accessesList="accessesList"
                            :administrator="administrator"
                            @deletedAdministrator="deletedAdministrator"/>
      </div>
    </div>
  </template>
</user-organization-container>`,
  created: function() {
    this._initAccessList();
    return this._initAdministratorsList();
  },
  methods: {
    deletedAdministrator: function(administrator) {
      return this.administratorsList = _.filter(this.administratorsList, function(item) {
        return item.id !== administrator.id;
      });
    },
    openAddAdminsModal: function() {
      return this.addAdminsModal = new AddAdminsModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add_admin_to_organization_modal_container'),
        propsData: {
          organization: this.organization,
          accessesList: this.accessesList,
          addAdminsCallback: (selectedAdmins) => {
            return this.addAdmins(selectedAdmins);
          }
        }
      });
    },
    addAdmins: function(admins) {
      admins = _.map(admins, function(admin) {
        return {
          access_id: admin.access.id,
          user_id: admin.admin.id
        };
      });
      return Skylark.Libs.Ajax.post(`/admin/organizations/${this.organization.id}/administrators`, {
        contentType: 'application/json; charset=utf-8',
        data: {
          administrator_relationship: admins
        },
        success: () => {
          newAlertify('添加组织管理员成功', {
            type: 'success'
          });
          this.addAdminsModal.cancel();
          return this._initAdministratorsList();
        },
        error: function() {
          return newAlertify('添加组织管理员失败', {
            type: 'error'
          });
        }
      });
    },
    _initAccessList: function() {
      return Skylark.Libs.Ajax.get('/admin/accesses', {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        success: (res) => {
          return this.accessesList = res;
        }
      });
    },
    _initAdministratorsList: function() {
      return Skylark.Libs.Ajax.get(`${this.resources}`, {
        contentType: 'application/json, text/javascript',
        responseType: 'json',
        success: (res) => {
          return this.administratorsList = res;
        }
      });
    }
  }
});
